import { ActionTree, Commit, GetterTree, MutationTree } from 'vuex'
import userApi from '../../api/user.js'

export interface RootState {
    version: string;
}

export class userType {
    value: number | undefined;
    text: string | undefined;
    accessLevel: number | undefined;
}
const state = Array<userType>();
const getters: GetterTree<Array<userType>, RootState> = {
    userType(state: Array<userType>) {
        return state
    }
};
export const mutations: MutationTree<Array<userType>> = {
    LOAD_USERTYPES(state: Array<userType>, userTypes: Array<userType>) {
        state.length = 0;
        userTypes.forEach(element => {
            state.push(element)
        });
    },
    CLEAR_USERTYPES(state: Array<userType>) {
        state.length = 0
    }
};
const actions: ActionTree<Array<userType>, RootState> = {
    async getUserTypes({ state, commit }: { commit: Commit, state: Array<userType> }): Promise<Array<userType>> {
        commit('CLEAR_USERTYPES')
        if (state && state.length > 0) return state;
        try {
            const data = [{ text: "System", value: 1, accessLevel: 1 },
            { text: "LH", value: 2, accessLevel: 2 },
            { text: "CLP", value: 3, accessLevel: 3 },
            { text: "LLP", value: 4, accessLevel: 4 },
            { text: "TS", value: 5, accessLevel: 5 },
            { text: "Driver", value: 6, accessLevel: 6 }]
            commit('LOAD_USERTYPES', data)
            return state;

        }
        catch (error) {
            commit('CLEAR_USERTYPES')
            return state;
        }
    }
}
export default {
    state,
    getters,
    mutations,
    actions
}